import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=d3c3de5c&scoped=true"
import script from "./AreaTable.vue?vue&type=script&lang=ts"
export * from "./AreaTable.vue?vue&type=script&lang=ts"
import style0 from "./AreaTable.vue?vue&type=style&index=0&id=d3c3de5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c3de5c",
  null
  
)

export default component.exports